import _import from './_import.js';

export default [
	// 新闻中心
	{
		path: 'about/news',
		component: _import('about/news')
	},
	// 关于glocalme
	{
	  path: 'about/glocalme_old',
	  component: _import('about/glocalme')
	},
	// 联系glocalme
	{
	  path: 'about/contact_old',
	  component: _import('about/contact')
	},
	// 寻找合作
	{
	  path: 'about/partnership',
	  component: _import('about/partnership')
	},
	// 新闻详情
	{
		path: 'about/newsDetail/:id',
		component: _import('about/newsDetail'),
	}
];




// WEBPACK FOOTER //
// ./src/router/about.js